// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__S-G2k","icon":"Skill_icon__71aLr","ContainerInfo":"Skill_ContainerInfo__T+10J","description":"Skill_description__RD3Dm"};